import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import axios from "axios";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { appendSasToken, removeSasFromDescription } from "../../Imagehelper";
import { fields } from "../constants";
import { usePageDocumentDetails } from "./Promotion.hooks";

export const AddEditMyairportsPromotion = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editPageContent,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = usePageDocumentDetails(query.get("editId") || "");

  const {
    data: editPageContentById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  const [currentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "pageHeading") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const [records, setRecords] = useState<any[]>([]);

  const getRecords = () => {
    let url = `${centralizedHost}/api/promotions-my-airports`;
    axios
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const formConfig: FormConfig = {
    initialValues: {
      title: editPageContentById
        ? decodeHTML(editPageContentById.payload?.title)
        : editPageContent
          ? decodeHTML(editPageContent?.title)
          : "",

      title_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.title_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.title_malay)
          : "",

      title_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.title_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.title_mandarin)
          : "",

      long_description: editPageContentById
        ? decodeHTML(editPageContentById.payload?.long_description)
        : editPageContent
          ? decodeHTML(editPageContent?.long_description)
          : "",

      long_description_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.long_description_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.long_description_malay)
          : "",

      long_description_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.long_description_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.long_description_mandarin)
          : "",

      short_description: editPageContentById
        ? decodeHTML(editPageContentById.payload?.short_description)
        : editPageContent
          ? decodeHTML(editPageContent?.short_description)
          : "",

      short_description_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload?.short_description_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.short_description_malay)
          : "",

      short_description_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload?.short_description_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.short_description_mandarin)
          : "",

      repeat_for_days: editPageContentById
        ? decodeHTML(editPageContentById.payload?.repeat_for_days)
        : editPageContent
          ? decodeHTML(editPageContent?.repeat_for_days)
          : "",

      frequency_count: editPageContentById
        ? decodeHTML(editPageContentById.payload?.frequency_count)
        : editPageContent
          ? decodeHTML(editPageContent?.frequency_count)
          : "",

      frequency_time: editPageContentById
        ? decodeHTML(editPageContentById.payload?.frequency_time)
        : editPageContent
          ? decodeHTML(editPageContent?.frequency_time)
          : "",

      location: editPageContentById
        ? decodeHTML(editPageContentById.payload?.location)
        : editPageContent
          ? decodeHTML(editPageContent?.location)
          : "",

      offer: editPageContentById
        ? decodeHTML(editPageContentById.payload?.offer)
        : editPageContent
          ? decodeHTML(editPageContent?.offer)
          : "",

      navigation_link: editPageContentById
        ? decodeHTML(editPageContentById.payload?.navigation_link)
        : editPageContent
          ? decodeHTML(editPageContent?.navigation_link)
          : "",

      start_date: editPageContentById
        ? decodeHTML(editPageContentById.payload?.start_date)
        : editPageContent
          ? decodeHTML(editPageContent?.start_date)
          : "",

      end_date: editPageContentById
        ? decodeHTML(editPageContentById.payload?.end_date)
        : editPageContent
          ? decodeHTML(editPageContent?.end_date)
          : "",

      image: editPageContentById
        ? editPageContentById.payload?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.image),
              },
            ]
          : []
        : editPageContent?.image
          ? [
              {
                uid: "-1",
                name: "image.jpg",
                status: "done",
                url: appendSasToken(editPageContent.image),
              },
            ]
          : [],

      banner_image: editPageContentById
        ? editPageContentById.payload?.banner_image
          ? [
              {
                uid: "-1",
                name: "bannerImage.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.banner_image),
              },
            ]
          : []
        : editPageContent?.banner_image
          ? [
              {
                uid: "-1",
                name: "bannerImage.jpg",
                status: "done",
                url: appendSasToken(editPageContent.banner_image),
              },
            ]
          : [],

      square_image: editPageContentById
        ? editPageContentById.payload?.square_image
          ? [
              {
                uid: "-1",
                name: "squareImage.jpg",
                status: "done",
                url: appendSasToken(editPageContentById.payload.square_image),
              },
            ]
          : []
        : editPageContent?.square_image
          ? [
              {
                uid: "-1",
                name: "squareImage.jpg",
                status: "done",
                url: appendSasToken(editPageContent.square_image),
              },
            ]
          : [],

      notification_type: editPageContentById
        ? decodeHTML(editPageContentById.payload.notification_type)
        : editPageContent
          ? decodeHTML(editPageContent?.notification_type)
          : null,

      repeat_type: editPageContentById
        ? decodeHTML(editPageContentById.payload.repeat_type)
        : editPageContent
          ? decodeHTML(editPageContent?.repeat_type)
          : null,

      type: editPageContentById
        ? decodeHTML(editPageContentById.payload.type)
        : editPageContent
          ? decodeHTML(editPageContent?.type)
          : null,
      shop_category: editPageContentById
        ? (editPageContentById.payload?.shop_category ?? null)
        : (editPageContent?.shop_category ?? null),

      project_airport_id: editPageContentById
        ? decodeHTML(editPageContentById.payload.project_airport_id)
        : editPageContent
          ? decodeHTML(editPageContent?.project_airport_id)
          : "",

      published: editPageContentById
        ? decodeHTML(editPageContentById.payload?.published)
        : editPageContent
          ? decodeHTML(editPageContent?.published)
          : "",

      sequence: editPageContentById
        ? decodeHTML(editPageContentById.payload.sequence)
        : editPageContent
          ? decodeHTML(editPageContent?.sequence)
          : "",

      terms_condition: editPageContentById
        ? decodeHTML(editPageContentById.payload.terms_condition)
        : editPageContent
          ? decodeHTML(editPageContent?.terms_condition)
          : "",

      terms_condition_malay: editPageContentById
        ? decodeHTML(editPageContentById.payload.terms_condition_malay)
        : editPageContent
          ? decodeHTML(editPageContent?.terms_condition_malay)
          : "",

      terms_condition_mandarin: editPageContentById
        ? decodeHTML(editPageContentById.payload.terms_condition_mandarin)
        : editPageContent
          ? decodeHTML(editPageContent?.terms_condition_mandarin)
          : "",
    },

    // fields: fields.myAirportsPromotions,

    fields: fields.promotion.map((field: any) => {
      if (field.name === "sequence") {
        return {
          ...field,
          validation: {
            // required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;

              const selectedAirports = formValues.project_airport_id || [];

              const existingRecord = records.find((record: any) => {
                const sameSequence = toInteger(record.sequence) === toInteger(value);

                const isSameRecord = record.id === (editPageContent?.id || editPageContentById?.payload?.id);

                const airportOverlap = record.project_airport_id?.some((airportId: string) =>
                  selectedAirports.includes(airportId)
                );

                return sameSequence && airportOverlap && !isSameRecord;
              });

              return !existingRecord || `${field.label || field.name} already exists for selected airport`;
            },
          },
        };
      }

      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "banner_image", "square_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          const cleanUrl = field[0].url.split("?sp=")[0];
          data[key] = cleanUrl;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    let descriptionKeys: any = [
      "long_description",
      "long_description_malay",
      "long_description_mandarin",
      "short_description",
      "short_description_malay",
      "short_description_mandarin",
    ];
    for (const key of descriptionKeys) {
      if (data[key]) {
        data[key] = removeSasFromDescription(data[key]);
      }
    }

    const payload = {
      action,
      method,
      module: "Centralized Promotions",
      subModule: "promotion",
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes,
      appList: [{ appName: "CENTRALIZED", apiUrl }],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageContent?.id || editPageContentById?.payload?.id,
        }),
        ...data,
      },
      status,
    };

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Promotions`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${centralizedHost}/api/promotions-my-airports/${editPageContent?.id || editPageContentById?.payload?.id}` : `${centralizedHost}/api/promotions-my-airports`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this MyAirports Promotions"
      />
    </ContentWrapper>
  );
};
